import { render, staticRenderFns } from "./DeleteMemberBankAccountForm.vue?vue&type=template&id=1febbe5d&"
import script from "./DeleteMemberBankAccountForm.vue?vue&type=script&lang=js&"
export * from "./DeleteMemberBankAccountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports